import { Button } from "@shared/ui/Button";
import { CheckCircle } from "@shared/ui/CheckCircle";

type Props = {
  label?: string;
  isAvailable: boolean;
  isCompleted: boolean;
  isDisabled: boolean;
  isButtonDisabled: boolean;
  onClick: () => void;
};

export function ProgramPhaseActionButton({
  label,
  isAvailable,
  isCompleted,
  isDisabled,
  isButtonDisabled = false,
  onClick,
}: Props) {
  if (isDisabled) return null;

  return (
    <div className="w-full md:w-auto">
      {isCompleted && !isAvailable ? (
        <div className="flex w-10">
          <CheckCircle isDisabled={isDisabled} />
        </div>
      ) : (
        <Button
          className="w-full mt-4 md:mt-0 md:w-fit"
          onClick={onClick}
          data-testid="program-phase-action"
          disabled={isButtonDisabled}
        >
          {label}
        </Button>
      )}
    </div>
  );
}

export default ProgramPhaseActionButton;
